import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/LangToggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RegisterAlternateLinks"] */ "/app/src/lib/context/AlternateLinksContext.tsx");
